<app-confirm-deletion-dialog
        [bodyHtml]="dialogBody"
        [dialogCloseObject]="data.id"/>
